export default __webpack_public_path__ + "static/media/product1.8034a843.jpeg";